<template>
    <div class="form-group">
        <label :for="id">{{label}}</label>
        <div class="dropbox">
            <input type="file" multiple :name="name" :disabled="isSaving"
                   @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                   accept="image/*" class="input-file"
                   :id="id"
            >
            <p v-if="isInitial">
                Перетащите один или несколько файлов в эту область<br> или выберите файл на компьютере
            </p>
            <p v-if="isSaving">
                Загружаются {{ fileCount }} файлов...
            </p>
            <!--SUCCESS-->
            <div v-if="isSuccess">
                <h2>Загружено {{ value.length }} файлов успешно.</h2>
                <!--<p>-->
                <!--<a href="javascript:void(0)" @click="reset()">Загрузить новые</a>-->
                <!--</p>-->
                <ul class="list-unstyled">
                    <li v-for="item in value">
                        <img :src="item.url" class="img-responsive img-thumbnail" :alt="item.originalName">
                    </li>
                </ul>
            </div>
            <!--FAILED-->
            <div v-if="isFailed">
                <h2>Произошла ошибка.</h2>
                <p>
                    <a href="javascript:void(0)" @click="reset()">Повторить</a>
                </p>
                <pre>{{ uploadError }}</pre>
            </div>
        </div>
    </div>
</template>

<script>
  import { upload } from '../../api/file'
  import { randomString } from '../../utils/string'

  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3

  export default {
    name: 'file-input',
    props: {
      name: {
        type: String,
        required: true
      },
      value: {
        type: Array,
        default: () => {
          return []
        }
      },
      id: {
        type: String,
        default: () => {
          return randomString()
        }
      },
      label: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        uploadError: null,
        currentStatus: null
      }
    },
    computed: {
      isInitial () {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving () {
        return this.currentStatus === STATUS_SAVING
      },
      isSuccess () {
        return this.currentStatus === STATUS_SUCCESS
      },
      isFailed () {
        return this.currentStatus === STATUS_FAILED
      }
    },
    methods: {
      reset () {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL
        this.$emit('input', [])
        this.uploadError = null
      },
      async save (formData) {
        // upload data to the server
        this.currentStatus = STATUS_SAVING

        try {
          let res = await upload(formData)
          this.$emit('input', [].concat(res))
          this.currentStatus = STATUS_SUCCESS
        } catch (err) {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        }
      },
      filesChange (fieldName, fileList) {
        // handle file changes
        const formData = new FormData()

        if (!fileList.length) return

        // append the files to FormData
        Array.from(Array(fileList.length).keys()).map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })

        // save it
        this.save(formData)
      }
    },
    mounted () {
      this.reset()
    }
  }
</script>

<style lang="scss" scoped>
    .dropbox {
        outline: 2px dashed grey; /* the dash box */
        outline-offset: -10px;
        background: lightcyan;
        color: dimgray;
        padding: 10px 10px;
        min-height: 200px; /* minimum height */
        position: relative;
        cursor: pointer;
    }

    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    .dropbox:hover {
        background: lightblue; /* when mouse over to the drop zone, change color */
    }

    .dropbox p {
        font-size: 1.2em;
        text-align: center;
        padding: 50px 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/form/FileInput.vue